import React, { useEffect } from "react";
import { logEvent } from "@Lib/analytics";
import styles from "./index.module.less";
import cx from "classnames";

function _gaEvent(action, label) {
  logEvent("影音詳細頁", action, label);
}

function openShare(data, share, status) {
  let url =
    data.link ||
    data.shareLink + "?utm_source=share&utm_medium=pc&utm_campaign=daily share&utm_term=" + data.id + "-" + data.title;

  _gaEvent(`${status == 1 ? "上" : "下"}-分享-${share}`, data.title);
  if (share == "FB") {
    window.open("https://www.facebook.com/share.php?u=" + encodeURIComponent(url), "_blank", "width=670,height=500");
  } else {
    window.open(
      "https://social-plugins.line.me/lineit/share?url=" + data.link || data.shareLink + "",
      "_blank",
      "width=670,height=500",
    );
  }
}

interface IProps {
  status: string | number;
  data: any;
}

const Share: React.FC<IProps> = ({ status, data }) => {
  useEffect(() => {}, []);

  return (
    <section className={cx({ [styles["Share-1"]]: status == 1 }, { [styles["Share-2"]]: status == 2 })}>
      <div className={styles["line-item"]} onClick={() => openShare(data, "line", status)}>
        <img src='https://photo.8891.com.tw/2023/04/20/1681985224455727.png' alt='' />
        <div className={styles["name"]}>Line</div>
      </div>
      <div className={styles["facebook-item"]} onClick={() => openShare(data, "FB", status)}>
        <img src='https://photo.8891.com.tw/2023/04/20/1681985224544139.png' alt='' />
        <div className={styles["name"]}>Facebook</div>
      </div>
      {status == 2 && (
        <div className={styles["triangle-item"]}>
          <img src='https://photo.8891.com.tw/2023/04/20/1681985224535878.png' alt='' />
        </div>
      )}
    </section>
  );
};

export default Share;
